import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as api from './api';
import * as selectors from './selectors';
import { Toast, normalize, downloadFile } from '../core';
import { baseRequest } from '../core/actions';

export const changeFiltersDateRange = (startDate, endDate) => dispatch => {
    dispatch({
        type: actionTypes.CAHNGE_FILTERS_DATE_RANGE,
        payload: {
            startDate,
            endDate
        }
    });
};

export const changeRegionFilter = region => dispatch => {
    dispatch({
        type: actionTypes.CHANGE_REGION_FILTER,
        payload: {
            region
        }
    });
};

export const getOverview = () => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_OVERVIEW_STATS.REQUEST });
    const filters = selectors.getFilters(getState());
    return api
        .getOverview(filters)
        .then(response => {
            dispatch({
                type: actionTypes.GET_OVERVIEW_STATS.SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_OVERVIEW_STATS.ERROR });
        });
};

export const getRegistrations = (pagination = {}) => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_NEW_COMPANIES.REQUEST });
    const adminDashboardFilters = selectors.getFilters(getState());
    return api
        .getRegistrations({ ...adminDashboardFilters, ...pagination })
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_NEW_COMPANIES.SUCCESS,
                payload: {
                    pagination,
                    ...normalize.normalizeArray(data)
                }
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_NEW_COMPANIES.ERROR });
        });
};

export const downloadRegistrationsReport = () => (dispatch, getState) => {
    dispatch({ type: actionTypes.DOWNLOAD_REPORT.REQUEST });
    const filters = selectors.getFilters(getState());
    return api
        .downloadRegistrationsReport(filters)
        .then(response => {
            dispatch({ type: actionTypes.DOWNLOAD_REPORT.SUCCESS });
            downloadFile(response.data, `New_Companies_Report_${moment().utc()}.csv`);
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.DOWNLOAD_REPORT.ERROR });
        });
};

export const getRegistrationsChartData = () => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_NEW_COMPANIES_CHART_DATA.REQUEST });
    const filters = selectors.getFilters(getState());
    return api
        .getRegistrationsChartData(filters)
        .then(response => {
            dispatch({
                type: actionTypes.GET_NEW_COMPANIES_CHART_DATA.SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_NEW_COMPANIES_CHART_DATA.ERROR });
        });
};

export const removeRegistrations = (ids, pagination = {}) => dispatch => {
    dispatch({ type: actionTypes.REMOVE_REGISTRATIONS.REQUEST });
    return api
        .removeRegistrations(ids)
        .then(() => {
            dispatch({
                type: actionTypes.REMOVE_REGISTRATIONS.SUCCESS
            });
            dispatch(getRegistrations(pagination));
            dispatch(getRegistrationsChartData());
            dispatch(getOverview());
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.REMOVE_REGISTRATIONS.ERROR });
        });
};

// Usage Report

export const getUsageReportData = (pagination = {}) => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_USAGE_REPORT_DATA.REQUEST });
    return api
        .getUsageReportData(pagination)
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_USAGE_REPORT_DATA.SUCCESS,
                payload: {
                    pagination,
                    ...normalize.normalizeArray(data)
                }
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_USAGE_REPORT_DATA.ERROR });
        });
};

// Subscription Cancellations

export const getCancellationsOverview = () => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_CANCELLATIONS_OVERVIEW.REQUEST });
    const filters = selectors.getFilters(getState());
    return api
        .getCancelaltionsOverview(filters)
        .then(response => {
            dispatch({
                type: actionTypes.GET_CANCELLATIONS_OVERVIEW.SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_CANCELLATIONS_OVERVIEW.ERROR });
        });
};

export const getCancellations = (pagination = {}) => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_CANCELLATIONS.REQUEST });
    const adminDashboardFilters = selectors.getFilters(getState());
    return api
        .getCancellations({ ...adminDashboardFilters, ...pagination })
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_CANCELLATIONS.SUCCESS,
                payload: {
                    pagination,
                    ...normalize.normalizeArray(data)
                }
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_CANCELLATIONS.ERROR });
        });
};

export const getCancellationsChartData = () => (dispatch, getState) => {
    dispatch({ type: actionTypes.GET_CANCELLATION_CHART_DATA.REQUEST });
    const filters = selectors.getFilters(getState());
    return api
        .getCancellationsChartData(filters)
        .then(response => {
            dispatch({
                type: actionTypes.GET_CANCELLATION_CHART_DATA.SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_CANCELLATION_CHART_DATA.ERROR });
        });
};

export const getSyncJobs = baseRequest({
    actionType: actionTypes.GET_SYNC_JOBS_DATA,
    apiCall: api.getSyncJobsData
});

export const removeSyncJobs = baseRequest({
    actionType: actionTypes.REMOVE_SYNC_JOBS_DATA,
    apiCall: api.removeSyncJobsData
});
